/**
 * Portal centralizado de aplicaciones (SSO).
 *
 * Cuando la app corre integrada al portal (REACT_APP_REDIRECT_TO_APPS = true),
 * esta aplicación deja de resolver el inicio de sesión por su cuenta: cualquier
 * situación en la que no haya sesión válida (nunca la hubo, el usuario cerró
 * sesión, el token expiró y no se pudo renovar, u otra app cerró la sesión SSO
 * en otra pestaña) termina enviando el navegador a REACT_APP_SSO_APPS_URL, que
 * es quien vuelve a autenticar y reparte hacia las apps.
 */

const rawAppsUrl = process.env.REACT_APP_SSO_APPS_URL;
const rawRedirectFlag = process.env.REACT_APP_REDIRECT_TO_APPS;

const TRUTHY_FLAG_VALUES = ["true", "1", "yes", "si", "sí"];

/** URL del portal de apps, o cadena vacía si no está configurada. */
export const getAppsPortalUrl = () =>
  typeof rawAppsUrl === "string" ? rawAppsUrl.trim() : "";

/**
 * Indica si la app debe delegar el inicio de sesión en el portal.
 * Requiere el flag activo y una URL configurada: sin URL no hay a dónde ir y
 * conviene conservar el comportamiento propio antes que dejar al usuario
 * atascado.
 */
export const isAppsPortalRedirectEnabled = () =>
  TRUTHY_FLAG_VALUES.includes(String(rawRedirectFlag).trim().toLowerCase()) &&
  Boolean(getAppsPortalUrl());

/**
 * Envía el navegador al portal de apps.
 * Usa `replace` para que el botón "atrás" no devuelva a una pantalla de la app
 * que ya no tiene sesión.
 * @returns {boolean} `true` si se disparó la navegación.
 */
export const redirectToAppsPortal = () => {
  const url = getAppsPortalUrl();

  if (!url) {
    return false;
  }

  window.location.replace(url);
  return true;
};

/**
 * Redirige al portal solo si la integración está habilitada.
 * Pensado para usarse como guarda temprana: si retorna `true`, el llamador debe
 * abandonar su flujo normal de login/logout porque el navegador ya está saliendo.
 * @returns {boolean} `true` si se disparó la navegación al portal.
 */
export const redirectToAppsPortalIfEnabled = () =>
  isAppsPortalRedirectEnabled() && redirectToAppsPortal();
